<template>
<div>
     <v-data-table :search="search" :single-select="singleSelect" v-model="selected" show-select :footer-props="{
               showFirstLastPage: true,
               firstIcon: 'mdi-arrow-collapse-left',
               lastIcon: 'mdi-arrow-collapse-right',
               prevIcon: 'mdi-minus',
               nextIcon: 'mdi-plus',
               }" :headers="headers" class="elevation-1 mt-0 px-5" :items="demande" :height="inerHeight">

          <template v-slot:top>
               <v-toolbar flat color="white">
                    <v-toolbar-title style="font-size: 25px">{{$t('demndDevis') + ':'}}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-autocomplete class="ma-4 mt-11" :items="isView" clearable dense v-model="filters.isShow" :label="$t('isView')" :item-text="localLang=='fr' ? 'isView' : 'isViewAr'" item-value="id" outlined></v-autocomplete>

                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="10" transition="scale-transition" offset-y min-width="240px">
                         <template v-slot:activator="{ on }">
                              <v-text-field class="ma-4" @click:clear="clirtext" dense hide-details outlined v-model="dateRangeText" :label="$t('dateDF')" clearable readonly v-on="on"></v-text-field>
                         </template>
                         <v-date-picker v-model="filters.date_rendez_vous" range></v-date-picker>
                    </v-menu>

                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn @click="deleteMulti" v-on="on" class="ma-2" hide-details tile color="red">
                                   <v-icon color="white" size="30">mdi-delete-sweep</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('deleteMulti') }}</span>
                    </v-tooltip>

               </v-toolbar>
          </template>

          <template v-slot:item.date_rendez_vous="{ item }">
               <v-chip dark color="grey lighten-1" v-if="item.date_rendez_vous == '1111-11-11'">/</v-chip>
               <v-chip dark color="blue lighten-2" v-else>{{ item.date_rendez_vous }}</v-chip>
          </template>
          <template v-slot:item.created_at="{ item }">
               <v-chip dark color="grey lighten-0">{{ item.created_at | moment }}</v-chip>
          </template>
          <template v-slot:item.isShow="{ item }">
               <v-chip dark color="red lighten-1" v-if="item.isShow == '0'">
                    <v-icon>mdi-eye-off</v-icon>
               </v-chip>
               <v-chip dark color="green lighten-2" v-else>
                    <v-icon>mdi-eye</v-icon>
               </v-chip>
          </template>
          <template v-slot:item.file="{ item }">
               <span v-if="item.file != '/'" @click="showPDF(item,1)" class="btnShowModal">{{ item.file }}</span>
               <span v-if="item.file == '/'">
                    <v-icon color="red">mdi-close</v-icon>
               </span>
          </template>
          <template v-slot:item.fileResponse="{ item }">
               <span v-if="item.fileResponse != '/'" @click="showPDF(item,2)" class="btnShowModal">{{ item.fileResponse }}</span>
               <span v-if="item.fileResponse == '/'">
                    <v-icon color="red">mdi-close</v-icon>
               </span>
          </template>

          <template v-slot:item.action="{ item }">
               <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                         <v-btn v-on="on" icon color="green" @click="updateResponse(item)">
                              <v-icon size="27"> mdi-beaker-question-outline </v-icon>
                         </v-btn>
                    </template>
                    <span>{{ $t('details') }}</span>
               </v-tooltip>

               <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                         <v-btn v-on="on" icon color="red" @click="removeItem(item)">
                              <v-icon size=30>mdi-delete-outline </v-icon>
                         </v-btn>
                    </template>
                    <span>{{ $t('supprimer') }}</span>
               </v-tooltip>
               <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                         <v-btn v-on="on" icon color="orange" @click="openSendResponse(item)">
                              <v-icon size=30>mdi-send-circle-outline </v-icon>
                         </v-btn>
                    </template>
                    <span>{{ $t('response') }}</span>
               </v-tooltip>

          </template>
     </v-data-table>

     <v-dialog v-model="dialog" persistent max-width="900">
          <v-card>
               <v-card-title class="headline">
                    {{ $t('detailDevis')  }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="red" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <v-row>
                         <v-col cols="12" lg="6" md="6" sm="12">
                              <v-col cols="12">
                                   <v-text-field class="ma-0" dense hide-details v-model="form.nom" outlined :label="$t('nom')" append-icon="mdi-account-outline" readonly></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                   <v-text-field class="ma-0" dense hide-details outlined v-model="form.email" :label="$t('email')" append-icon="mdi-email-outline" readonly></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                   <v-text-field class="ma-0" dense hide-details outlined v-model="form.telephone" :label="$t('phone')" append-icon="mdi-email-outline" readonly></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                   <v-textarea outlined rows="6" hide-details v-model="form.message" readonly append-icon="mdi-message-outline" :label="$t('msg')"></v-textarea>
                              </v-col>
                         </v-col>
                         <v-col cols="12" lg="6" md="6" sm="12">
                              <iframe :src="infoPdf.file | URL3" width="100%" height="400"></iframe>
                         </v-col>
                    </v-row>
               </v-card-text>
          </v-card>
     </v-dialog>

     <v-dialog class="" v-model="dialog15" max-width="700">
          <v-card>
               <v-card-title class="headline ">{{ $t(entet) }}</v-card-title>
               <v-card-text>
                    <iframe :src="infoPdf.file | URL3" width="100%" height="600"></iframe>
               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="dialog15 = false">{{ $t('close') }}</v-btn>
               </v-card-actions>
          </v-card>
     </v-dialog>
     <v-dialog class="" v-model="dialog12" persistent max-width="500">
          <v-card>
               <v-card-title class="headline ">{{ $t('sendDevis') }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="red" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <v-row>
                         <v-col cols="12">
                              <v-textarea outlined rows="6" hide-details v-model="response.reponse" 
                               append-icon="mdi-message-outline" :label="$t('response')"></v-textarea>
                         </v-col>
                         <v-col @click="$refs.img.click()" class="my-1 py-0" cols="12">
                              <input type="file" ref="img" hidden @change="selectImage">
                              <v-text-field dense hide-details outlined  :label="$t('chargImgrespon') " 
                              clearable prepend-icon="mdi-file" readonly @change="selectImage" v-model="fileExmpl"> </v-text-field>
                         </v-col>
                    </v-row>
               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!loading"  color="green darken-1" class="ma-2"   dark  @click="sendResponse">{{ $t('send') }}</v-btn>
                     <span class="pa-2"  v-else>{{ $t('patienter') }}</span>
               </v-card-actions>
          </v-card>
     </v-dialog>
</div>
</template>

<script>
export default {
     data: () => ({
          loading: false,
          fileExmpl:'',
          entet:'',
          form: {},
          response: {},
          dialog: false,
          dialog12: false,
          dialog15: false,
          date: new Date().toISOString().substr(0, 10),
          infoPdf: {},
          menu2: false,
          menu3: false,
          filters: {
               isShow: '',
               date_rendez_vous: [],
          },
          isView: [{
                    id: 0,
                    isView: 'Non vue',
                    isViewAr: 'لم يتم رؤيتها',
               },
               {
                    id: 1,
                    isView: 'Vue',
                    isViewAr: 'تم رؤيتها',
               },
          ],
          dialog15: false,
          search: '',
          singleSelect: false,
          selected: [],
          inerHeight: window.innerHeight - 290,
          headers: [{
                    text: localStorage.getItem('lang') == 'fr' ? 'Le nom' : 'الإسم',
                    value: 'nom',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'E-mail' : 'البريد الإلكتروني',
                    value: 'email',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Téléphone' : 'الهاتف',
                    value: 'telephone',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Fichier' : 'الملف',
                    value: 'file',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Vue' : 'تم الرؤية',
                    value: 'isShow',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Fichier de devis envoyé' : 'ملف التسعيرة المرسل',
                    value: 'fileResponse',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Date de devis' : 'تاريخ الطلب',
                    value: 'created_at',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Action' : 'الحدث',
                    value: 'action',
                    align: 'center',
                    sortable: false
               },
          ],
     }),
     methods: {
          init() {
               this.form = {
                    type: 1,
                    nom: '',
                    email: '',
                    telephone: '',
                    file: '',
                    message: '',
                    reponse: '',
                    date_rendez_vous: new Date().toISOString().substr(0, 10),
                    domainName: document.location.origin,
               }
               this.response = {
                    id:'',
                    type: 1,
                    email: '',
                    fileResponse: '',
                    reponse: '',
                    domainName: document.location.origin,
               }
          },
          selectImage(e) {
               const file = e.target.files[0]
               this.response.fileResponse = file
               this.fileExmpl = file.name
          },
          saveDemande() {
               var url = 'getDemandes/addDemandes'
               var commit = 'getDemandes'

               this.$Register({
                    data: JSON.stringify(this.form)
               }, url, commit).then((res) => {
                    this.init()
                    this.dialog = false
               })

          },
          clirtext(e) {
               this.filters.dateRangeText = ['', '']
          },
          showPDF(item, num) {
               this.dialog15 = true
               if (num == 1) {
                    this.entet = 'demndDevis'
               } else {
                    this.entet = 'devisEnvyee'
               }
               this.infoPdf = {},
                    console.log('item', item)
               this.infoPdf = item
          },
          updateResponse(data) {
               
               this.form = data
               this.form.type = 1
               this.form.date_rendez_vous = new Date().toISOString().substr(0, 10)
               this.form.types = 0
               this.infoPdf = data

               this.dialog = true
               var url = 'getDemandes/changeVue'
               var commit = 'getDemandes'

               this.$Register({
                    data: JSON.stringify(data)
               }, url, commit)
               this.$store.dispatch('getDemandes')
          },
          openSendResponse(data) { 
               this.response.id = data.id
               this.response.email = data.email
               this.dialog12 = true
               // var url = 'getDemandes/changeVue'
               // var commit = 'getDemandes'
          },
          sendResponse() {
               this.loading = true
               this.$store.dispatch('sendResponse', {
                    data: JSON.stringify(this.response),
                    fileResponse:this.response.fileResponse
               }).then((res) => {
                    this.loading = false
                    this.dialog12 = false
                    this.init()
               }).catch((err) => {
                    this.loading = false
               })
               this.$store.dispatch('getDemandes')
          },
          removeItem(data) {
               this.$store.dispatch('deleteDemande', {
                    data: JSON.stringify(data)
               })
               this.$store.dispatch('getDemandes')
          },
          deleteMulti() {
               this.$store.dispatch('deleteDemande', {
                    data: JSON.stringify(this.selected)
               })
               this.$store.dispatch('getDemandes')
          },
          close() {
               this.dialog = false
               this.dialog12 = false
          }
     },
     computed: {
          dateRangeText() {
               return this.filters.date_rendez_vous.join(' ~ ')
          },

          demande() {
               return new this.$MultiFilter(this.$store.state.demande.filter(e => e.types == 1), this.filters).filterData()
          }
     },
     created() {
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
          this.init()
          window.addEventListener('resize', () => {
               this.inerHeight = window.innerHeight - 270
          })

          Fire.$on('search', (search) => {
               this.search = search
          })
     }
}
</script>

<style>

</style>
